import { callAgroApi } from '@services/agroapi';
export interface Selection {
  season_id: string | null;
  labels: string[] | null;
  farms: string[] | null;
}
export interface AssignmentPayload {
  name: string;
  template_id: string;
  selection: Selection;
  include_cz: string[];
  exclude_cz: string[];
}
export const withAssignments = self => ({
  actions: {
    createAssignment(assignmentData: AssignmentPayload, orgId: string) {
      return callAgroApi(`/organizations/${orgId}/template_assignments`, 'POST', assignmentData);
    },
    deleteAssignment(assignmentId: string) {
      return callAgroApi(`/template_assignments/${assignmentId}`, 'DELETE');
    }
  }
});